import { render, staticRenderFns } from "./TemplateSelect.vue?vue&type=template&id=3582e418&scoped=true"
import script from "./TemplateSelect.vue?vue&type=script&lang=js"
export * from "./TemplateSelect.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelect.vue?vue&type=style&index=0&id=3582e418&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3582e418",
  null
  
)

export default component.exports